import { AcademyCourse } from '../../models/academy-course.model';

export const chatMessagesCourse: AcademyCourse = {
  slug: 'react-to-chat-messages',
  trainingModuleId: 'chat_response',
  titleKey: 'texts.Tutor_Academy_Course_Chat_Messages_Title',
  descriptionKey: 'texts.Tutor_Academy_Course_Chat_Messages_Description',
  isMandatory: false,
  hasSearchBoost: true,
  lessons: [
    {
      id: 'reageer-snel',
      titleKey: 'texts.Tutor_Academy_ChatMessages_L1_Title',
      subtitleKey: 'texts.Tutor_Academy_ChatMessages_L1_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L1_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L1_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_ChatMessages_L1_Item1',
            'texts.Tutor_Academy_ChatMessages_L1_Item2',
            'texts.Tutor_Academy_ChatMessages_L1_Item3'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L1_Paragraph3' }
      ]
    },
    {
      id: 'je-eerste-antwoord',
      titleKey: 'texts.Tutor_Academy_ChatMessages_L2_Title',
      subtitleKey: 'texts.Tutor_Academy_ChatMessages_L2_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L2_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L2_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_ChatMessages_L2_Item1',
            'texts.Tutor_Academy_ChatMessages_L2_Item2',
            'texts.Tutor_Academy_ChatMessages_L2_Item3',
            'texts.Tutor_Academy_ChatMessages_L2_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L2_Paragraph3' }
      ]
    },
    {
      id: 'blijf-bij-het-gesprek',
      titleKey: 'texts.Tutor_Academy_ChatMessages_L3_Title',
      subtitleKey: 'texts.Tutor_Academy_ChatMessages_L3_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L3_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L3_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_ChatMessages_L3_Item1',
            'texts.Tutor_Academy_ChatMessages_L3_Item2',
            'texts.Tutor_Academy_ChatMessages_L3_Item3'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L3_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L3_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L3_Paragraph5' }
      ]
    },
    {
      id: 'voorbeelden',
      titleKey: 'texts.Tutor_Academy_ChatMessages_L4_Title',
      subtitleKey: 'texts.Tutor_Academy_ChatMessages_L4_Subtitle',
      headingKey: 'texts.Tutor_Academy_ChatMessages_L4_Heading',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_ChatMessages_L4_Download_Url',
      actionLabelKey: 'texts.Tutor_Academy_ChatMessages_L4_Download_Link',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L4_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L4_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_ChatMessages_L4_Item1',
            'texts.Tutor_Academy_ChatMessages_L4_Item2',
            'texts.Tutor_Academy_ChatMessages_L4_Item3',
            'texts.Tutor_Academy_ChatMessages_L4_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L4_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_ChatMessages_L4_Paragraph4' }
      ]
    }
  ],
  quiz: [
    {
      id: 'reactiesnelheid',
      questionKey: 'texts.Tutor_Academy_ChatMessages_Q1_Question',
      isMultiSelect: false,
      answers: [
        { id: 'tien-minuten', textKey: 'texts.Tutor_Academy_ChatMessages_Q1_Answer1' },
        { id: 'zes-uur', textKey: 'texts.Tutor_Academy_ChatMessages_Q1_Answer2' },
        { id: 'een-week', textKey: 'texts.Tutor_Academy_ChatMessages_Q1_Answer3' },
        { id: 'maakt-niet-uit', textKey: 'texts.Tutor_Academy_ChatMessages_Q1_Answer4' }
      ],
      correctAnswerIds: ['zes-uur'],
      explanationKey: 'texts.Tutor_Academy_ChatMessages_Q1_Explanation'
    },
    {
      id: 'eerste-antwoord',
      questionKey: 'texts.Tutor_Academy_ChatMessages_Q2_Question',
      isMultiSelect: false,
      answers: [
        { id: 'dag-en-tijd', textKey: 'texts.Tutor_Academy_ChatMessages_Q2_Answer1' },
        { id: 'uitgebreid-verhaal', textKey: 'texts.Tutor_Academy_ChatMessages_Q2_Answer2' },
        { id: 'vriendelijke-groet', textKey: 'texts.Tutor_Academy_ChatMessages_Q2_Answer3' },
        { id: 'tarief', textKey: 'texts.Tutor_Academy_ChatMessages_Q2_Answer4' }
      ],
      correctAnswerIds: ['dag-en-tijd'],
      explanationKey: 'texts.Tutor_Academy_ChatMessages_Q2_Explanation'
    },
    {
      id: 'navragen',
      questionKey: 'texts.Tutor_Academy_ChatMessages_Q3_Question',
      isMultiSelect: false,
      answers: [
        { id: 'opdringerig', textKey: 'texts.Tutor_Academy_ChatMessages_Q3_Answer1' },
        { id: 'navragen', textKey: 'texts.Tutor_Academy_ChatMessages_Q3_Answer2' },
        { id: 'gesprek-voorbij', textKey: 'texts.Tutor_Academy_ChatMessages_Q3_Answer3' },
        { id: 'aan-de-ouder', textKey: 'texts.Tutor_Academy_ChatMessages_Q3_Answer4' }
      ],
      correctAnswerIds: ['navragen'],
      explanationKey: 'texts.Tutor_Academy_ChatMessages_Q3_Explanation'
    }
  ]
};
